<div class="filter-viewer">
  <ng-container
    *ngIf="
      filters != null &&
      (filterToDisplay | json) != ({} | json) &&
      filterToDisplay != null
    "
  >
    <p class="tw-font-medium tw-text-gray-700 dark:tw-text-gray-200 tw-mb-3">
      {{ "pages.confirmSmartSmsRequest.filter.yourMessageSendTo" | translate }}
    </p>
    <ng-container *ngFor="let filter of filters">
      <div class="tw-mb-4" *ngIf="isInDisplayFilter(filter)">
        <list-group-item
          *ngIf="filter.enumName == 'age'"
          [label]="filter.enumTitle"
          [value]="getFilterText(filter)"
        >
        </list-group-item>
        <div
          *ngIf="filter.enumName != 'age'"
          class="tw-border dark:tw-border-dark-100 border-radius"
        >
          <div
            class="list-group-item tw-flex tw-justify-between tw-items-center"
            class="tw-py-2 tw-my-1 tw-px-4 tw-flex tw-justify-between"
          >
            <div class="tw-flex-center">
              <span
                class="tw-font-medium dark:tw-text-gray-200"
                [class]="filter.enumTitle"
              >
                {{ filter.enumTitle | translate }}
              </span>
            </div>
            <div class="dir-ltr tw-pt-2">
              <ng-container
                *ngFor="let item of filterToDisplay[filter.enumName]"
              >
                <span
                  copyToClipboard
                  class="badge badge-light border tw-text-gray-800 dark:tw-text-gray-200 tw-mx-1 tw-text-[13px] text-wrap dir-rtl pre-wrap dir-ltr tw-text-left"
                  [innerHTML]="item || '-'"
                ></span>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="filters == null || filterToDisplay == null">
    <div class="tw-flex tw-justify-center tw-pt-5">
      <div
        class="spinner-border text-primary tw-mr-2 tw-w-[40px] tw-h-[40px]"
        role="status"
      >
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </ng-container>
</div>
